import { AxiosResponse } from 'axios';

import { Plan } from '@videoblocks/subscription-service-client';
import { LoggerFactory } from '@videoblocks/typescript-logger';

import { getCompanionPlanCode } from './PlanCodes';
import { planApi } from './subscriptionServiceConfig';

const logger = LoggerFactory.create('PlanApi');

const listPlans = async (): Promise<Plan[] | null> => {
    try {
        const result = await planApi.getPlans();
        return result.data;
    } catch (error) {
        logger.info(error);
        return null;
    }
};

const getPlanById = async (id: string): Promise<Plan | null> => {
    try {
        const result = await planApi.getPlanById({ id });
        return result.data;
    } catch (error) {
        logger.info(error);
        return null;
    }
};

const getPlanByCode = async (planId: string): Promise<Plan | null> => {
    try {
        const result = await planApi.getPlanById({
            id: `code-${planId}`,
        });
        return result.data;
    } catch (error) {
        logger.info(error);
        return null;
    }
};

const getMonthlyPlan = async (planCode: string): Promise<Plan | null> => {
    const plan = await getPlanByCode(planCode);

    if ((plan?.intervalUnit === 'months' && plan.intervalLength == 1) || plan?.intervalUnit === 'days') {
        return plan;
    }

    return await getPlanByCode(getCompanionPlanCode(planCode));
};

const getYearlyPlan = async (planCode: string): Promise<Plan | null> => {
    const plan = await getPlanByCode(planCode);

    if (plan?.intervalUnit === 'years' || (plan?.intervalUnit === 'months' && plan.intervalLength == 12)) {
        return plan;
    }

    return await getPlanByCode(getCompanionPlanCode(planCode));
};

export const PlansApi = {
    listPlans,
    getPlanById,
    getPlanByCode,
    getMonthlyPlan,
    getYearlyPlan,
};
